import React from 'react'
import { PageNotFound } from './Pages/pageNotFound'
import { TermsOfSevice } from './Pages/TermsOfService'
import { About } from './Pages/About'
import { SignInPage } from './Pages/signIn/signIn'
import ManageLog4netConfig from './Pages/log4NetConfig/log4NetConfig'
import Registration from './Pages/registration/registration'
import { ForgotPasswordPage } from './Pages/forgotPassword/forgotPassword'
import MDSTool from './Pages/MDSTool'
import IndividualSummary from './Components/SummaryTiles/Summary'
import HomeBase from './Pages/HomePage/Home'
import WlmForm from './Pages/WLM/wlmForm'
import WlmList from './Pages/WLM/wlmList'
import AppDimensionTable from './Pages/ManageAppDimensions/ManageDimension'
import AppDimensionRows from './Pages/ManageAppDimensions/AppDimensionRows'
import EditAppDimensionRows from './Pages/ManageAppDimensions/EditAppDimensionRows'
import AddNewAppDimensionRows from './Pages/ManageAppDimensions/AddNewAppDimensionRows'
import GetAdminProcedure from './Pages/AdminProcedure'
import RunAdminProcedure from './Pages/RunAdminTools'
import DataMapperTool from './Pages/DataMapperTool/DataMapperTool'
import Contact from './Pages/contact/contact'
import BusinessparameterList from './Pages/BusinessParameter/BusinessparameterList'
import ManageBusinessParameters from './Pages/BusinessParameter/AddNewBuisnessPrameter'
import BusinessParametersEdit from './Pages/BusinessParameter/EditBusinessParameter'
import { TargetRubric } from './Components/TargetRubric/TargetRubric'
import SummaryDrillThru from './Components/DrillThru/DrillThru'
import WorkspaceActionsDropdown from './Pages/Workspace/workspaceActionsDropdown'
import WorkspacePage, { ZustandWorkspacePageContextWrapper } from './Pages/Workspace/workspace'
import UserSettings from './Pages/UserSettingsPage/UserSettings'
import ManageRole from './Pages/ManageRole/ManageRole'
import ViewActivityAndAudits from './Pages/manageActivity/ViewActivityAndAudits'
import Invite from './Pages/sendInvite/invite'
import { RunSqlQueries } from './Pages/RunSQLQueries/RunSqlQueries'
import ResetPasswordForm from './Pages/ResetPassword/ResetPassword'
import SendEmailConfirmation from './Pages/EmailConfirmation/sendEmailConfirmation'

import { BrowserRouter as Router, Routes, Route, useLocation, Link, Navigate  } from "react-router-dom";
import { useSelector } from 'react-redux';
import { getAppWorkflowState, getCurrentUserData, RootState } from './Redux/store';
import { PageFrame } from './GenericComponents/PageFrame/PageFrame'
import { appWorkflowStates } from './Types/appWorkflowStates'
import { OCVSaveAsPDF } from './Components/OCV/OCVSaveasPDF'
import  AdminTasks  from "./Pages/AdminTasks/adminTasks";
import  emailConfirmation  from './Pages/registration/emailConfirmation'
import ManageUserAccounts from './Pages/UserAccounts/ManageUserAccounts'
import FormsEngine from './Pages/FormsEngine/FormEngine'
import { ManageFormsEngineConfig } from './Pages/FormsEngineConfiguration/manageFormsEngineConfig'

// TODO: redo routing: https://semaphoreci.com/blog/routing-layer-react
/*
    This component controls basic routing for the app. 
    To create a new route:
    1. Import the component for your page
    2. Add a new object to the routes array
    3. Give it a name, path, and pass your component to the element field
*/
type FooterAlignment = 'start' | 'center' | 'between' | 'end';

interface RouteOptions {
  hasHeader: boolean;
  hasFooter: boolean;
  footerAlignment?: FooterAlignment;
}

interface RouteEntry {
  pattern: RegExp;
  component: any;
  isProtected: boolean;
  options: RouteOptions;
}

const routeConfig: RouteEntry[] = [
    { pattern: /^\#signin$/, component: SignInPage, isProtected: false, options : { hasHeader: false, hasFooter: true,footerAlignment: 'center'}},
    { pattern: /^#home(?:\?ref=(?:detach_workspace|del_workspace))?$/, component: HomeBase, isProtected: true, options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#about$/, component: About, isProtected: false,  options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#terms$/, component: TermsOfSevice, isProtected: false, options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#Log4netConfig$/, component: ManageLog4netConfig, isProtected: true , options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#ManageUsers$/, component: ManageUserAccounts, isProtected: true , options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#register(?:\?.*)?$/, component: Registration, isProtected: false , options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}}, //TODO pass optiosn some how
    { pattern: /^\#react\/MDSTool$/, component: MDSTool, isProtected: true , options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#BusinessParameters$/, component: BusinessparameterList, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#BusinessParameters\/add$/, component: ManageBusinessParameters, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#BusinessParameters\/edit(?:\?[0-9a-fA-F-]{36})?$/, component:BusinessParametersEdit, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#contact$/, component: Contact, isProtected: false ,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#forgot-password$/, component: ForgotPasswordPage, isProtected: false ,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#UserSettings$/, component: UserSettings, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#datamapper$/, component: DataMapperTool, isProtected: true ,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#appdimensions$/, component : AppDimensionTable, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#appdimensions\/rows(?:\?Guid=[0-9a-fA-F-]{36})?$/, component : AppDimensionRows, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}}, //Expected pattern example: #appdimensions/rows?Guid=13dceb31-9597-48ec-b038-f6e1a874eba4
    { pattern: /^\#EditAppDimensionRows(?:\?Guid=[0-9a-fA-F-]{36}&rowId=\d+)?$/, component : EditAppDimensionRows, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}}, // Expected pattern example: #EditAppDimensionRows?Guid=13dceb31-9597-48ec-b038-f6e1a874eba4&rowId=5
    { pattern: /^\#appdimensions\/add(?:\?Guid=[0-9a-fA-F-]{36})?$/, component : AddNewAppDimensionRows, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}}, // Expected pattern example: #appdimensions/add?Guid=13dceb31-9597-48ec-b038-f6e1a874eba4
    { pattern: /^\#ManageAdminTools$/, component :GetAdminProcedure, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#ManageAdminTools\/run(?:\?Guid=[0-9a-fA-F-]{36})?$/, component : RunAdminProcedure, isProtected: true ,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#admin\/manage-roles$/, component :ManageRole, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#RunSqlQueries$/, component : RunSqlQueries, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#Invite$/, component: Invite , isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#manageAudit$/, component: ViewActivityAndAudits, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#manage-forms-engine$/, component: ManageFormsEngineConfig, isProtected: true, options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},

    // { pattern: /^\#reset-password$/, component :ResetPasswordForm, isProtected: false,options : { hasHeader: true, hasFooter: true}},
    // { pattern: /^#reset-password\?id=([0-9a-fA-F-]{36})&tid=([^&]+)&linkGuid=([0-9a-fA-F-]{36})$/, component :ResetPasswordForm, isProtected: false,options : { hasHeader: true, hasFooter: true}},
    {
        pattern: /^#reset-password\?(?=.*\bid=([0-9a-fA-F-]{36}))(?=.*\btid=([^&]+))(?=.*\blinkGuid=([0-9a-fA-F-]{36})).*$/,
        component: ResetPasswordForm,
        isProtected: false,
        options: { hasHeader: true, hasFooter: true,footerAlignment: 'start' }
    },
    {
        pattern: /^#email-confirmation\?(?=.*\bid=([0-9a-fA-F-]{36}))(?=.*\btid=([^&]+)).*$/,
        component: emailConfirmation,
        isProtected: false,
        options: { hasHeader: true, hasFooter: true,footerAlignment: 'start' }
    },
    { pattern: /^\#workspace\/(.*)$/, component: ZustandWorkspacePageContextWrapper, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#workspace\/KMIs\/notfications\/(.*)$/, component: WorkspacePage, isProtected: true,options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^\#UserSettings\/ChangePassword$/, component:UserSettings, isProtected: true, options : { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    { pattern: /^#AdminTasks$/, component: AdminTasks, isProtected: true, options: { hasHeader: true, hasFooter: true,footerAlignment: 'start'}},
    {
        pattern: /^#OCV\/GenericView\/(.*)\/(.*)$/,
        component: OCVSaveAsPDF,
        isProtected: true,
        options: { hasHeader: true, hasFooter: true,footerAlignment: 'start' }
    },
    {
        pattern: /^#OCV\/DefaultView\/(.*)\/(.*)$/,
        component: OCVSaveAsPDF,
        isProtected: true,
        options: { hasHeader: true, hasFooter: true,footerAlignment: 'start' }
    },
    { 
        pattern: /^\#send-email-confirmation$/, 
        component: SendEmailConfirmation, 
        isProtected: false, 
        options: { hasHeader: true, hasFooter: true,footerAlignment: 'start' } 
    },
    {
         pattern: /^#FormsEngine\?(?=.*\bformName=[^&]+)(?=.*\bdataObjectId=[^&]+)(?=.*\bguid=[^&]+)(?=.*\bnavigationenabled=[^&]+).*$/, 
         component: FormsEngine, 
         isProtected: true,
         options : { hasHeader: true, hasFooter: true,footerAlignment: 'start' }
    },
  ];
  
  const AppRouter = () => {
    const location = useLocation();
    const hash = window.location.hash;
    const currentUserData = useSelector(
        (state: RootState) => getCurrentUserData(state)
    )
    const appWorkflowState = useSelector(
          (state: RootState) => getAppWorkflowState(state)
        )
    const matchedRoute = routeConfig.find(route => route.pattern.test(hash));
    let pageParams: any = null
    if(matchedRoute) {
        const match = hash.match(matchedRoute?.pattern)
        pageParams = match
    }
    //TODO: FP-10887 - Page Protection logic should not  be here. 
    if (appWorkflowState == appWorkflowStates.UNAUTHENTICATED && matchedRoute?.isProtected) {
        return <Navigate to="#signin" replace />;
    }
    return matchedRoute ? (
        <>
            <Navigate to={hash} replace />
            <PageFrame hasHeader={matchedRoute.options?.hasHeader} hasFooter={matchedRoute.options?.hasFooter} footerAlignment={matchedRoute.options?.footerAlignment}>
            {React.createElement(matchedRoute.component, pageParams)}
            </PageFrame>
        </>
    ) : (
        <PageNotFound />
    );
  };

  export default AppRouter;